import { useState, useEffect } from "react";
import { APIKEY, APIID } from "../config.js";

const minimum = 40000;
const url = `http://api.adzuna.com/v1/api/jobs/gb/search/1?app_id=${APIID}&app_key=${APIKEY}&results_per_page=50&what=software%20engineer&salary_max=${minimum}&content-type=application/json`

const Junior = () => {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchJobs = async () => {
        const data = await fetch(url);
        const dataJSON = await data.json();
        setIsLoading(false);
        setData(dataJSON.results);
        console.log(dataJSON.results);
    }

    useEffect(() => {
        fetchJobs();
    }, []);

    const JuniorLoading = () => {
        return (
            <div class="loading-div"></div>
        );
    }

    return (
        <main>
            <i></i>
            <h3 class="logo">JUNIOR</h3>
            {isLoading ? <JuniorLoading /> : data.map((datum) => {
            const { company, contract_type, created, description, id, location, salary_max, salary_min, title, redirect_url } = datum;
            const range = `${salary_min} - ${salary_max}` || "Competitive";

            return (
                <div key={id} class="content">
                    <h4 class="title">{title}</h4>
                    <h4 class="range">{range}</h4>
                    <h5 class="company-name">{company.display_name}</h5>
                    <h5 class="contract-type">{contract_type}</h5>
                    <h6 class="date">{created.slice(0, 10)}</h6>
                    <h5 class="location">{location.display_name}</h5>
                    <p class="description">{description}</p>
                    <button>
                    <a href={redirect_url}>MORE</a>
                    </button>
                    <br />
                </div>
            );
        })}
        </main>
    )
}

export { Junior };